import { required } from 'vuelidate/lib/validators';

const itemValidation = {
  minWeight: {
    required,
  },
  maxWeight: {
    required,
  },
  deliveryPrice: {
    required,
  },
};

export default itemValidation;